import {
  Waves,
  Sun,
  Trees,
  Flame,
  Baby,
  Armchair,
  TreePine,
  Wifi,
  Car,
  CigaretteOff,
} from "lucide-react";
import { useReveal } from "../hooks/useReveal";
import { useLanguage } from "../lib/LanguageContext";

export const Facilities = () => {
  const ref = useReveal();
  const { t } = useLanguage();

  const items = [
    { icon: Waves, label: t("fac_pool") },
    { icon: Sun, label: t("fac_sun") },
    { icon: Trees, label: t("fac_garden") },
    { icon: Flame, label: t("fac_bbq") },
    { icon: Baby, label: t("fac_kids") },
    { icon: Armchair, label: t("fac_seating") },
    { icon: TreePine, label: t("fac_picnic") },
    { icon: Wifi, label: t("fac_wifi") },
    { icon: Car, label: t("fac_parking") },
    { icon: CigaretteOff, label: t("fac_nonsmoking") },
  ];

  return (
    <section
      id="facilities"
      data-testid="facilities-section"
      className="py-24 md:py-36 bg-[#faf9f6]"
    >
      <div ref={ref} className="reveal max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-16">
          <div className="text-[10px] uppercase tracking-[0.28em] text-[#6b705c] mb-6">
            {t("fac_eyebrow")}
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-[#0a192f] leading-[1.02]">
            {t("fac_title_a")}{" "}
            <em className="italic text-[#1a5b73]">{t("fac_title_b")}</em>{" "}
            {t("fac_title_c")}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 md:gap-6">
          {items.map((it, i) => (
            <div
              key={i}
              data-testid={`facility-${i}`}
              className="group bg-white border border-[#0a192f]/10 rounded-2xl p-6 md:p-8 flex flex-col items-start justify-between min-h-[170px] md:min-h-[200px] hover:shadow-xl hover:-translate-y-1 transition-all duration-500"
            >
              <div className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-[#e8e3d9] text-[#1a5b73] group-hover:bg-[#1a5b73] group-hover:text-white transition-colors duration-500">
                <it.icon className="h-5 w-5" strokeWidth={1.4} />
              </div>
              <div className="mt-6 text-[13px] md:text-sm text-[#0a192f] leading-snug">
                {it.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
